function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
}

function getDotObject(obj: Record<string, unknown>, str: string): unknown {
    let current: unknown = obj;

    for (const key of str.split('.')) {
        if (!isRecord(current)) {
            return undefined;
        }
        current = current[key];
    }

    return current;
}

// ----------------------------------------------------------------------------

export default getDotObject;
